// angular
import { NgClass } from '@angular/common';
import { Component, inject, input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
// components
import { MegaMenuSkeletonComponent } from './mega-menu-skeleton/mega-menu-skeleton.component';
// services
import { LayoutService } from '@app/layout/shared/services/layout.service';
// constants
import { CategoriesType } from '@app/+categories/shared/types/categories.type';
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';

@Component({
  selector: 'pwj-mega-menu',
  standalone: true,
  imports: [
    RouterModule,
    TranslateModule,
    NgClass,
    TranslateDataPipe,
    MegaMenuSkeletonComponent,
  ],
  templateUrl: './mega-menu.component.html',
  styleUrl: './mega-menu.component.scss',
})
export class MegaMenuComponent implements OnInit {
  public productTypes: CategoriesType[] = [];
  public productNames: CategoriesType[] = [];

  public currentProductCategory!: CategoriesType;
  public currentProductType!: CategoriesType;
  public currentProductName!: CategoriesType;

  // inputs
  categoriesData = input<CategoriesType[]>([]);
  // dependencies
  private readonly _layoutService = inject(LayoutService);
  constructor() {}

  ngOnInit(): void {
    this.currentProductCategory = this.categoriesData()?.[0];
    this.onSelectCategory(this.categoriesData()?.[0]);
  }

  public onSelectCategory(category: CategoriesType) {
    this.productTypes = category?.children;
    this.currentProductCategory = category;

    this.onSelectSubCategory(this.productTypes?.[0]);
  }

  public onSelectSubCategory(subCategory: CategoriesType) {
    this.productNames = subCategory?.children;
    this.currentProductType = subCategory;
  }

  public closeMegaMenu() {
    this._layoutService.hiddenMegaMenu.set(true);
    this._layoutService.hiddenAdvancedFilters.set(true);
    this._layoutService.hiddenAdvancedFilters.set(true);
    this._layoutService.windowIsOpen.set(false);
  }
}
